export default "__VITE_ASSET__CYpLTz95__"